export default {"src":"/_next/static/media/logo.ede44b3d.svg","height":82,"width":200,"blurWidth":0,"blurHeight":0};